"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RecommendedFastenersWidget_1 = __importDefault(require("./RecommendedFastenersWidget"));
exports.default = RecommendedFastenersWidget_1.default;
